import type { TafsirLanguage } from '@/types/domain';
import {
  TranslationPillGroup,
  TranslationPill,
} from '@/components/ui/TranslationPillGroup';

type TafsirLanguageToggleProps = {
  value: TafsirLanguage;
  onChange: (next: TafsirLanguage) => void;
};

const OPTIONS: { v: TafsirLanguage; label: string }[] = [
  { v: 'en', label: 'En' },
  { v: 'ur', label: 'Ur' },
];

export function TafsirLanguageToggle({
  value,
  onChange,
}: TafsirLanguageToggleProps) {
  return (
    <TranslationPillGroup ariaLabel="Tafsir language">
      {OPTIONS.map((opt) => (
        <TranslationPill
          key={opt.v}
          active={value === opt.v}
          dot
          onClick={() => onChange(opt.v)}
          ariaLabel={`Tafsir ${opt.label}`}
        >
          {opt.label}
        </TranslationPill>
      ))}
    </TranslationPillGroup>
  );
}